/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Globals from "../shared/Globals";
import { qreq } from "../shared/qrequest";
import Alert from "./Alert";
import BaseCom from "./BaseCom";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { Link } from "react-router-dom";

class SearchResults extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            leads: [],
            comments: []
        };
        this.load = this.load.bind(this);
        this.loadLeads = this.loadLeads.bind(this);
        this.loadComments = this.loadComments.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (this.props.params.query !== prevProps.params.query) {
            this.load();
        }
    }

    load() {
        if (this.props.params.query) {
            this.setState({ loaded: false });
            qreq.post('/api/order/list', { search: this.props.params.query }, j => {
                if (j.errorCode)
                    this.setState({ error: j.errorMessage });
                else if (j.list) {
                    this.setState({ orders: j.list });
                }
                this.loadLeads(this.props.params.query);
            }, () => {
                this.setState({ error: 'Unknown error. Please try again...', loaded: true });
            });
        }
    }

    loadLeads(query) {
        if (query) {
            qreq.post('/api/lead/list?bucket=all&saveFilter=false', { search: this.props.params.query }, j => {
                if (j.list)
                    this.setState({ leads: j.list });
                else
                    this.alert(j.errorMessage);
                this.loadComments(this.props.params.query);
            }, () => {
                this.setState({ error: 'Unknown error. Please try again...', loaded: true });
            });
        }
    }

    
    loadComments(query) {
        if (query) {
            qreq.get('/api/comment/search?query=' + query, j => {
                if (j.list)
                    this.setState({ comments: j.list });
                else
                    this.alert(j.errorMessage);
                this.setState({ loaded: true });
            }, () => {
                this.setState({ error: 'Unknown error. Please try again...', loaded: true });
            });
        }
    }

    render() {
        const header = <h1>Search Results</h1>;
        if (!this.state.loaded)
            return <div className="container-fluid">{header}<LoadingAlert /></div>;

        return <div className="container-fluid SearchResults">
            {header}
            {this.state.error ? <Alert type="danger">{this.state.error}</Alert> :
                this.state.loaded && this.state.orders.length === 0 && this.state.comments.length === 0 ? <Alert>No results found for: <i>{this.props.params.query}</i></Alert> : <p className="lead">Search query: <i>{this.props.params.query}</i></p>}
            {this.state.orders.length > 0 ? <>
                <h2 className="my-2">Orders</h2>
                <div className="mt-2 mb-3">
                    {this.state.orders.map(i => <Link key={i.id} to={'/order/view/' + i.id} role="button" className={'d-block rounded data-link drop-shadow p-3 mt-2' + (i.statusColor ? ' ' + i.statusColor : '')}>
                        <h4>#{i.oid}</h4>
                        <h5>{i.patientNameDOB}</h5>
                        <div>Status: <strong>{i.status}</strong></div>
                    </Link>)}
                </div>
            </> : null}
            {this.state.leads.length > 0 && <>
                <h2 className="my-2">Queue</h2>
                <div className="mt-2 mb-3">
                    {this.state.leads.map(i => <Link key={i.id} to={'/lead/edit/' + i.id} role="button" className="d-block rounded data-link drop-shadow p-3 mt-2">
                        <h4>Caller: {i.referrerName}</h4>
                        {i.patientName && <h5>{i.patientNameDOB}</h5>}
                        {i.isReferOut ? <div><strong>Refer Out</strong></div> : i.orderNextActionName && <div>Next Action: <strong>{i.orderNextActionName}</strong></div>}
                        {i.isOnHold && <div>On Hold</div>}
                        <div className="text-muted">Created: {Globals.toMDYHMLocalDateString(i.leadDate)}</div>
                    </Link>)}
                </div>
            </>}
            {this.state.comments && this.state.comments.length > 0 ? <>
                <h2 className="my-2">Comments</h2>
                <div className="mt-2 mb-3">
                    {this.state.comments.map(i => <Link key={i.id} to={'/order/view/' + i.orderID + '#comment-' + i.id} role="button" className="d-flex rounded data-link drop-shadow p-3 mt-2">
                        <img src="/img/placeholder.png" className="img-thumbnail c-avatar-sm d-block me-2" alt="" />
                        <div>
                            <strong className="d-block">{i.createdByUserName}</strong>
                            <i className="d-block">{Globals.toMDYHMLocalDateString(i.createdDate)} {i.visitID ? <Link to={'/visit/view/' + i.visitID + '#comment-' + i.id}>encounter scheduled on {Globals.toMDYHMLocalDateString(i.visitScheduleDate)}</Link> : null}</i>
                            <h5>{i.patientNameDOB}</h5>
                            <div dangerouslySetInnerHTML={{ __html: this.processComment(i.message)}}></div>
                        </div>
                    </Link>)}
                </div>
            </> : null}
        </div>;
    }
}

export default withParamsAndNavigate(SearchResults);